import { render, staticRenderFns } from "./r-plinko-stage-config-dialog.vue?vue&type=template&id=feb01ff0&scoped=true"
import script from "./r-plinko-stage-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-plinko-stage-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-plinko-stage-config-dialog.vue?vue&type=style&index=0&id=feb01ff0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb01ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feb01ff0')) {
      api.createRecord('feb01ff0', component.options)
    } else {
      api.reload('feb01ff0', component.options)
    }
    module.hot.accept("./r-plinko-stage-config-dialog.vue?vue&type=template&id=feb01ff0&scoped=true", function () {
      api.rerender('feb01ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-stage-config-dialog.vue"
export default component.exports